module.exports = __webpack_public_path__ + "img/femme_actuelle.0790a03.png";